(function() {
  window.EntryPosition = (function() {
    var _coords, _loc, _uriba_cd, _uriba_nm, _url;

    class EntryPosition {
      constructor(args) {
        navigator.geolocation.getCurrentPosition(function(e) {
          return _loc.resolve(e);
        }, function(e) {
          return _loc.reject(e);
        }, {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        });
      }

      get() {
        return _loc;
      }

    };

    _url = "/api/entry.jsonp";

    _loc = $.Deferred();

    _coords = null;

    _uriba_cd = "";

    _uriba_nm = "";

    return EntryPosition;

  }).call(this);

  $(function() {
    return $("div.stamp-box.ready").on("click", function(e) {
      var data, location, result, source, stamp, template;
      //HTML5 geoLocationに対応しているかどうか判定
      if (!navigator.geolocation) {
        alert('お使いの端末は位置情報を送信できません。');
        return false;
      }
      $("#modal-trigger").prop('checked', true);
      stamp = $(e.currentTarget);
      data = {
        cmp_id: stamp.attr('data-cmp_id')
      };
      location = new window.EntryPosition();
      result = location.get().then(function(e) {
        data.lat = String(e.coords.latitude);
        data.lng = String(e.coords.longitude);
        return $.ajax({
          url: '/race/campaign/api/entry.jsonp',
          type: 'POST',
          data: data,
          dataType: 'jsonp',
          jsonpCallback: 'response'
        });
      });
      source = $("#entry-message").html();
      template = Handlebars.compile(source);
      return result.then(function(e) {
        var html;
        switch (e.status) {
          case 'success':
            $("span[data-cmp_id=" + e.data.cmp_id + "]").removeClass('ready').addClass('after');
            stamp.removeClass('ready').addClass('after');
            e.msg_class = 'msg-success';
            break;
          case 'fail':
            e.msg_class = 'msg-error';
        }
        html = template(e);
        return $("#msg-area").html(html);
      }, function(e) {
        var html, msg;
        msg = {
          msg_class: 'msg-error'
        };
        switch (String(e.code)) {
          case "1":
            msg.message = '位置情報の取得が拒否されました。';
            break;
          case "2":
            msg.message = 'お使いの機器の位置判定に失敗しました。';
            break;
          case "3":
            msg.message = '位置判定がタイムアウトしました。';
        }
        console.log(e.code);
        html = template(msg);
        return $("#msg-area").html(html);
      }).always(function() {
        return $("#modal-trigger").prop('checked', false);
      });
    });
  });

}).call(this);

//# sourceMappingURL=main.js.map
